module.exports = __webpack_public_path__ + "img/gold-medal.0cf40145.svg";